module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "region-select"
  }, [_c('div', {
    staticClass: "info-control arr-item",
    on: {
      "click": _vm.showPal
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.labelName))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShow),
      expression: "!isShow"
    }]
  }, [_vm._v(_vm._s(_vm.select.province) + " " + _vm._s(_vm.select.city) + " " + _vm._s(_vm.select.area))])]), _vm._v(" "), (_vm.isShow) ? _c('div', {
    staticClass: "region-panel"
  }, [_c('v-distpicker', {
    attrs: {
      "type": "mobile"
    },
    on: {
      "province": _vm.selectProvince,
      "city": _vm.selectCity,
      "area": _vm.selectArea
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-657c56c5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddressSelect.vue
// module id = 846
// module chunks = 0